export default __webpack_public_path__ + "white-flag-symbol.png";